import { configureStore } from "@reduxjs/toolkit";
import cartReducer from "./cartSlice";
import userReducer from "./userSlice";
import shippingReducer from "./shippingSlice";
import orderReducer from "./orderSlice";
import resumeReducer from "./resumeSlice";

const store = configureStore({
  reducer: {
    cart: cartReducer,
    user: userReducer,
    shipping: shippingReducer,
    order: orderReducer,
    resume: resumeReducer,
  },
});

export default store;
